import {MOON_150} from '@wandb/weave/common/css/globals.styles';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const ArtifactFilesInner = styled.div`
  display: flex;
`;
ArtifactFilesInner.displayName = 'S.ArtifactFilesInner';

export const TreePanel = styled.div`
  min-width: 200px;
  max-width: 300px;
  margin-right: 8px;
  overflow: auto;
  border-right: 1px solid ${MOON_150};
`;
TreePanel.displayName = 'S.TreePanel';

export const FilePanel = styled.div`
  flex: 1 1 auto;
`;
FilePanel.displayName = 'S.FilePanel';
